import React, { Fragment, useMemo, useState, useEffect, useRef } from "react";
import { Tooltip } from 'primereact/tooltip';

import classes from './SideNav.module.css'
import SideNavItem from "../sideNavItem/sidNavItemV2/SideNavV2-Item";

import SeachIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Navigation Icons/__Search.svg'
import ActivityIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/activity.png'
import AllSites from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/home.png'
import Users from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/user.png'
import Groups from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/groups.png'
import CCTV from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cctvType.png'
import Locks from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/locks.png'
import Keybox from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/keybox.png'
import Sensor from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/sensor.png'
import Logout from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Navigation Icons/__Logout.svg'
import PortalActivity from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/group.png'
import LiveView from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/liveView.png'
import Offline from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/offline.png'
import Controller from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/controller.png'
import GatewayIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gatewayLogoPortalG.png'
import Dashboard from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dashboard.png'
import Schedule from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/schedule.png'
import emptySitesIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/empty.png'
import inactiveSitesIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/inactiveSidebar.png'
import activeSitesIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/activeSidebar.png'
import tempIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/deadline.png'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";

import EyeSpyFXLogo from '../../../../assets/eyespyfx-logo.png';
import ParfasLogo from "../../../../assets/parfas-logo.png"
import ResureLogo from "../../../../assets/resure-logo.png"
import KnowioLogo from "../../../../assets/knowio-logo.png"
import PortalLogo from "../../../../assets/portal-logo.png"
import TowerLogo from '../../../../assets/tower-logo.png'
import ctsgLogo from '../../../../assets/solar-logo.png'
import cscLogo from '../../../../assets/csc-logo.png'
import siteGuardLogo from '../../../../assets/siteguard-logo.png'
import siteGuardianLogo from '../../../../assets/siteguardian-logo.png'
import crimeGuardLogo from '../../../../assets/crimeguard-logo.png'
import redLogo from '../../../../assets/red-logo.png'

import { changePortalGroup, getAllGroups, getBranding, getGroups } from "../../../../Api Methods/Api";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { authActions } from "../../../../store/auth-Slice";
import Lottie from "lottie-react";
import loggingInAnim from '../../../../assets/animations/newLoading.json'

const SideNav = ({ collapsed = false, onToggle }) => {
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const role = useSelector(state => state.auth.role);
    const ApiData = {
        token,
        client
    }
    const dispatch = useDispatch();

    const companyName = useSelector(state => state.auth.companyName);
    const [brandingName, setBrandingName] = useState("")

    const [loadedLogo, setLoadedLogo] = useState(false)

    const clickCount = useRef(0);
    const timer = useRef(null);
    const [changeGroupVisible, setChangeGroupVisible] = useState(false)
    const [loadingGroups, setLoadingGroups] = useState(false)
    const [changingGroups, setChangingGroups] = useState(false)
    const [groups, setGroups] = useState([])
    const [selectedGroup, setSelectedGroup] = useState([])


    const GetBrandingName = async (groupName) => {
        let body = {
            groupName: groupName ?? companyName
        }

        const response = await getBranding(ApiData, body, dispatch)
        if (response.success){
            setBrandingName(response.data["emailBranding"])
        }
    }

    useEffect(() =>{
        GetBrandingName();
    }, [companyName])

    const handleImageClick = (e) => {
        const modifierPressed = (e.metaKey || e.ctrlKey) && e.shiftKey;
    
        if (!modifierPressed) {
          clickCount.current = 0;
          return;
        }
    
        clickCount.current += 1;
    
        if (clickCount.current === 5) {
          clickCount.current = 0;
          if (role === "admin"){
            openChangeGroupMenu();
          }
          return;
        }
    
        clearTimeout(timer.current);
    
        timer.current = setTimeout(() => {
          clickCount.current = 0;
        }, 1500);
      };

    const DefaultNavItems = [
        {
            name: 'Dashboard',
            imgSrc: Dashboard,
            route: '/Dashboard',
            end: true
        },
        {
            name: 'All sites',
            route: 'AllSites',
            imgSrc: AllSites,
            
        },
        
        {
            name: 'Active sites',
            route: 'ActiveSites',
            imgSrc: activeSitesIcon,
        },
        {
            name: 'Inactive sites',
            route: 'InactiveSites',
            imgSrc: inactiveSitesIcon,
        },
        {
            name: 'Live view',
            route: 'LiveViewSites',
            imgSrc: LiveView,
        },
        {
            name: 'iONs',
            route: 'Controllers',
            imgSrc: Controller,
        },
        {
            name: `Offline iON's`,
            route: 'Offline',
            imgSrc: Offline,
        },
        {
            name: 'Temporary schedules',
            route: 'TemporarySchedules',
            imgSrc: tempIcon,
        },
        {
            name: 'Scheduled sites',
            route: 'ScheduledActions',
            imgSrc: Schedule,
        },
        {
            name: 'Users',
            route: 'Users',
            imgSrc: Users,
        },
    ];

  
    DefaultNavItems.push({
        name: 'Groups',
        route: 'Groups',
        imgSrc: Groups,
    });
    DefaultNavItems.push({
        name: '3rd party CCTV',
        route: 'CCTVIntegrations',
        imgSrc: CCTV,
    });
    DefaultNavItems.push({
        name: 'Padlocks',
        route: 'Padlocks',
        imgSrc: Locks,
    });
    DefaultNavItems.push({
        name: 'Keyboxes',
        route: 'Keyboxes',
        imgSrc: Keybox,
    });
    DefaultNavItems.push({
        name: 'Sensors',
        route: 'Sensors',
        imgSrc: Sensor,
    });
    DefaultNavItems.push({
        name: 'Gateways',
        route: 'Gateways',
        imgSrc: GatewayIcon,
    });
    

    if (companyName === "EyeSpyFX" || companyName === "KNOWIO") {
        DefaultNavItems.push({
            name: 'Portal activity',
            route: 'Activity',
            imgSrc: PortalActivity,
        });
    }

    if (companyName === "EyeSpyFX" || companyName === "RE:SURE" || companyName === "KNOWIO"){
        DefaultNavItems.push({
            name: 'Site activity',
            route: 'SiteActivity',
            imgSrc: ActivityIcon,
            end: true
        });
    }

    let logo = "";
    let logoClass;
    switch (brandingName) {
        case "EyeSpyFX":
            logo = KnowioLogo;
            logoClass = classes.logo;
            break;
        case "PARFAS":
            logo = ParfasLogo;
            logoClass = classes.logo;
            break;
        case "RE:SURE":
            logo = ResureLogo;
            logoClass = classes.logo;
            break;
        case "SOLO":
            logo = ResureLogo;
            logoClass = classes.logo;
            break;
        case "PORTAL_SECURITY":
            logo = PortalLogo;
            logoClass = classes.logo;
            break;
        case "CPS":
            logo = ResureLogo;
            logoClass = classes.logo;
            break;
        case "EES":
            logo = ResureLogo;
            logoClass = classes.logo;
            break;
        case "KNOWIO":
            logo = KnowioLogo;
            logoClass = classes.logo;
            break;
        case "CTSG": 
            logo = ctsgLogo;
            logoClass = classes.logo
            break;
        case "Tower Security" :
            logo = TowerLogo;
            logoClass = classes.logo
            break;
        case "CSC" :
            logo = cscLogo;
            logoClass = classes.logo
            break;
        case "SiteGuard" :
            logo = siteGuardLogo;
            logoClass = classes.logo
            break;
        case "Site Guardian" :
            logo = siteGuardianLogo;
            logoClass = classes.logo
            break;
        case "CrimeGuard" :
            logo = crimeGuardLogo;
            logoClass = classes.logo
            break;
        case "RED CCTV" : 
            logo = redLogo;
            logoClass = classes.logo
            break;
        default:
            logo = KnowioLogo;
            logoClass = classes.logo;
            break;
    }

    useEffect(() => {
        if (logo !== ""){
            setLoadedLogo(true)
        }
    }, [logo])



    const navSettingsItems = useMemo(() => [
        
    ], []);


    const handleHideSideNav = () => {
        sessionStorage.removeItem("SavedSearchQuery");
        sessionStorage.removeItem("SavedSearchFilters");
        sessionStorage.removeItem("SavedSearchSortOrder");
        sessionStorage.removeItem("isGetAllDevicesPressed");
    }

    const openChangeGroupMenu = async () => {
        setChangeGroupVisible(true)
        setLoadingGroups(true)

        const response = await getAllGroups(ApiData, dispatch)
        if (response.success) {
            setGroups(response.data[0])
            setLoadingGroups(false)
        } else {
            //Failed to load
            setChangeGroupVisible(false)
        }
    }

    const updateGroup = async () => {
        setChangingGroups(true)
        const body = {
            newGroupID: selectedGroup.id
        }
        const response = await changePortalGroup(ApiData, body, dispatch)
        if (response.success){
            dispatch(authActions.setCompanyName(selectedGroup.name));
            setChangeGroupVisible(false);
            window.location.reload()
        }
    }

    return (
        <>
        
         <Dialog
            header="Change group"
            visible={changeGroupVisible}
            style={{ width: "40vw" }}
            onHide={() => setChangeGroupVisible(false)}
            >
                <div>
                {loadingGroups && 
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                        <Lottie
                            animationData={loggingInAnim}
                            loop={true}
                            style={{ width: 150, height: 150, margin: "0px" }}
                        />
                        <br />

                        <h3 style={{ color: "#6e6e6eff" }}>{`Authenticating user account, please wait...`}</h3>
                        
                        <br />
                    
                    </div>}

                    {!loadingGroups && 
                        <>
                            <div>
                                <p>Choose a new group from the dropdown below</p>
                                <Dropdown
                                    value={selectedGroup}
                                    className="w-full md:w-14rem"
                                    style={{ width: '400px' }}
                                    onChange={(e) => setSelectedGroup(e.value)}
                                    options={[...groups].sort((a, b) => a.name.localeCompare(b.name))}
                                    optionLabel="name"
                                    placeholder="Choose group"
                                    showClear
                                    filter
                                    filterPlaceholder="Search groups..."
                                />
                            </div>
    
                            <br></br>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Button label="Change group" severity="danger" onClick={() => updateGroup()} disabled={!selectedGroup} />
                            </div>
                        </>
                    }
                </div>
        </Dialog>
    
        <Fragment>
            <Tooltip target=".sidenav-tooltip" position="right" className="sidenav-tooltip-popup" showDelay={300} />
            <div className={`${classes['side-nav']} ${collapsed ? classes.collapsed : ''}`}>
                <div className={classes["nav-wrapper"]}>
                    <nav style={{ width: "100%" }}>
                        <ul className={classes["nav-listLinks"]}>

                            <div onClick={handleImageClick}>
                                {brandingName && loadedLogo ? (
                                    <img className={logoClass} src={logo} />
                                    ) : (
                                    <img className={logoClass}  />
                                )}
                            </div>
                                                    

                            {DefaultNavItems.map((item, index) => (
                                <li
                                    style={{
                                        width: "100%",
                                        cursor: item.disabled ? "" : "pointer",
                                        opacity: item.disabled ? 0.3 : 1,
                                    }}
                                    key={index}
                                >
                                <SideNavItem
                                    route={item.disabled ? null : item.route}
                                    image={item.imgSrc}
                                    text={item.name}
                                    onClick={!item.disabled ? handleHideSideNav : null}
                                    end={item.end}
                                    hideText={collapsed}
                                />
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <nav>
                        <ul className={classes["nav-listLinks"]}>
                            {navSettingsItems.map((item, index) => (
                                <li key={index}>
                                    <SideNavItem
                                        route={item.route}
                                        image={item.imgSrc}
                                        text={item.name}
                                        hideText={collapsed}
                                    />
                                </li>
                            ))}
                        </ul>
                    </nav>

                   
                        {/* <button
                            onClick={onToggle}
                            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
                        >
                            {collapsed ? 'COLLAPSE ›' : 'SHOW ‹'}
                        </button> */}
                        

                </div>
            </div>
        </Fragment>
        </>
    );
}

export default SideNav;